exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "food-benefit-manager .manager-bar{width:100%;padding:0 5px 5px;display:inline-flex;border-bottom:2px solid #dddfe2}food-benefit-manager .manager-bar.mobile{display:block;padding:0;border-bottom:none}food-benefit-manager .manager-bar.no-requests{border-bottom:none}food-benefit-manager employee-search-tags{margin-top:-70px;position:relative;top:70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/features/foodBenefitManager/foodBenefitManager.scss
// module id = 1582
// module chunks = 0